import Slider, { SLIDER_TYPES, ARROWS_VERTICAL_POSITION, CAROUSEL_TYPES } from './Slider';

export default Slider;
export { SLIDER_TYPES, ARROWS_VERTICAL_POSITION, CAROUSEL_TYPES };
